import { useContext } from 'react';

import { BlockedRecordDetailsContext } from './blocked-record-details-provider';

function useBlockedRecordDetails() {
  const context = useContext(BlockedRecordDetailsContext);

  if (!context) {
    throw new Error('useBlockedRecordDetails must be used within a BlockedRecordDetailsProvider');
  }

  return context;
}

export { useBlockedRecordDetails };
